export default __webpack_public_path__ + "static/media/djej.3c3c834d.PNG";